import { TimeWindowConfig } from "./recurrence.types";

export const isOvernight = (start: string, end: string) => {
  if (!start || !end) return false;

  const [startHour, startMinute] = start.split(":").map(Number);
  const [endHour, endMinute] = end.split(":").map(Number);

  const startMinutes = startHour * 60 + startMinute;
  const endMinutes = endHour * 60 + endMinute;

  return endMinutes <= startMinutes;
};

export const get12HourFormat = (time?: string): string => {
  if (!time) return "";

  const [h, m] = time.split(":").map(Number);
  const period = h >= 12 ? "PM" : "AM";
  const hour = h % 12 || 12;

  return `${hour}:${m.toString().padStart(2, "0")} ${period}`;
}

export const isInvalidTimeWindow = (timeWindow: TimeWindowConfig[]) => {
  if (!timeWindow || timeWindow.length === 0) return false;

  return (
    timeWindow.some((tw: TimeWindowConfig) => !tw.startTime || !tw.endTime) ||
    timeWindow.some(tw => isOvernight(tw.startTime, tw.endTime) && !tw.overNight)
  );
};